












































import { Prop, Component, Vue } from 'vue-property-decorator'
import { RealworksAPI } from '@/api/client/realworks'
import { Relatie } from '@/api/realworks-types'
import { Contact } from '@/api/model/contact'
import KvButton from '@/components/input/KvButton.vue'

@Component({
    components: {
        KvButton,
    },
})
export default class TypeformResponsesDetailRelatie extends Vue {
    @Prop({ required: true }) relatie!: Relatie
    contact: Contact = null

    async mounted() {
        this.contact = await RealworksAPI.getContactFromRelatie(this.relatie.id)
    }

    async navigateToContactDetail(): Promise<void> {
        if (!this.contact) {
            return
        }

        await this.$router.push({
            name: 'one_contact_detail',
            params: {
                contactId: this.contact.id,
                toOne: this.$currentUser.betaOptInEnabled ? 'true' : '',
            },
        })
    }

    get canNavigateToContactDetail(): boolean {
        return this.$currentUser.betaOptInEnabled
            && this.contact !== null
    }

    get fullname(): string {
        return [
            this.relatie.titel,
            this.relatie.initialen,
            this.relatie.tussenvoegsel,
            this.relatie.achternaam,
        ].join(' ')
    }

    get street(): string {
        return [
            this.relatie.adresgegevens.huisadres.huisadresRegel1,
            this.relatie.adresgegevens.huisadres.huisadresHuisnummer,
            this.relatie.adresgegevens.huisadres.huisadresHuisnummertoevoeging,
        ].join(' ')
    }

    get address(): string {
        return [
            this.relatie.adresgegevens.huisadres.huisadresPostcode,
            this.relatie.adresgegevens.huisadres.huisadresPlaats,
        ].join(' ')
    }
}
